import { Component, ComponentRef, ElementRef, EventEmitter,
  OnInit,Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { PatientService } from 'src/app/services/patient/patient.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RessourceSetting, RessourceTypeEnum } from 'src/app/utils/interfaces/new/RessourceSetting';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { MailizAccount } from 'src/app/pages/user/mss/inbox/mss.component';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';
import { ConnectToMailizComponent } from 'src/app/pages/user/mss/inbox/connect-to-mailiz/connect-to-mailiz.component';
import { ConnectToApicryptComponent } from 'src/app/pages/user/mss/inbox/connect-to-apicrypt/connect-to-apicrypt.component';
import { Subscription } from 'rxjs';
import { MSSAddress, MSSAttachment, MSSEnumTypeMail, MSSMessagePatientInfo, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MSS_EMAIL_REGEX } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { MssMessageDisplayComponent } from 'src/app/pages/user/mss/inbox/mss-message-display/mss-message-display.component';
import { MSSClinicalDocumentInfo } from 'src/app/utils/interfaces/new/mss-clinical-document-info.interface';
import { PresendClinicalDocumentModalComponent } from 'src/app/pages/user/mss/inbox/presend-clinicaldocument-modal/presend-clinicaldocument-modal.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../../utils/safe-html.util';
import { UploadGedDocument } from 'src/app/utils/interfaces/new/UploadGEDDocument';
import { DocumentService } from 'src/app/services/document/document.service';
import { LoginService } from 'src/app/services/login/login.service';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import moment from 'moment';
import { CourrierDestinataires, CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { AddCorrespondantCourrier } from '../add-correspondant-courrier/add-correspondant-courrier.fragment';
import { PATIENT_MSS_ADDRESS_SUFFIX } from 'src/app/services/mss/mss-service.abstract';
import { FroalaEditorDirective } from 'angular-froala-wysiwyg';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { TexteService } from 'src/app/services/texte/texte.service';
import { te } from 'date-fns/locale';
import { TexteModele } from 'src/app/utils/interfaces/new/TexteModele';
import { Annexe } from '../edit-courrier/edit-courrier.fragment';
import { CreateCourrier } from 'src/app/utils/interfaces/new/create-courrier.interface';
import { Courrier } from 'src/app/utils/interfaces/new/Courrier';

export interface NgSelectAccount {
  id: string;
  libelle: string;
}

const IDENTIFIANT_NATIONAL_KEY = 'identifiant-national';

const practiceSettingKey = 'dmp_params_practice_setting';
const identifiantNationalKey = 'identifiant-national';
const professionSettingKey = 'dmp_params_profession_setting';
const specialiteSettingKey = 'dmp_params_specialite_setting';
const nomSettingKey = 'dmp_params_nom_setting';
const prenomSettingKey = 'dmp_params_prenom_setting';
const idnatStructureSettingKey = 'dmp_params_idnatstruct_setting';
const nomStructureSettingKey = 'dmp_params_nomstruct_setting';
const typeStructureSettingKey = 'dmp_params_typestruct_setting';

const MAX_HEIGHT = 20;  // Représente la hauteur que l'on veut donner au visualisateur de PDF dans l'iframe

interface SelectedAccount {
  accountName: string;
  provider: MssTypeService;
}

export interface PieceJointe {
  contentType: 'application/pdf' | 'courrier-consultation';
  fileName: string;
  file: string; // prefixBase64
  size: number;
  clinicalDocument: boolean;
  documentAssocieId: string;
  typeDocumentAssocie?: string;
  clinicalDocumentData?: { xmlBase64: string };
}

@Component({
  selector: 'app-quick-send-mss',
  templateUrl: './quick-send-mss.fragment.html',
  styleUrls: ['./quick-send-mss.fragment.scss', '../modal.fragment.scss'],
  /**
   * Ce fragment est appelé dans une modal et ne récupère pas les modules
   * On les ajoute donc ici pour y avoir accès
   */
  providers: [DirectivesModule],
})
export class QuickSendMSSFragment implements OnInit {
  public static readonly titlePrefix = 'XDM/1.0/DDM+';
  editorContent: string = '';
  editorOptions: Object = {
    pluginsEnabled: [
      'table',
      'fontSize',
      'fontFamily',
      'link',
      'image',
      'emoticons',
      'specialCharacters',
      'embedly',
      'fullscreen',
      'selectAll',
      'help',
      'paragraphFormat',
      'paragraphStyle',
      'align',
      'lists',
      'colors',
      'lineHeight',
      'quote',
    ],
    fontSize: ['6', '8', '10', '12', '14', '16', '18', '24', '36'],
    language: 'fr',
    toolbarButtons: [
      [
        'insertTable',
        'insertLink',
        'insertImage',
        'embedly',
        'emoticons',
        'specialCharacters',
      ],
      [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'textColor',
        'backgroundColor',
        'clearFormatting',
      ],
      ['fontFamily', 'fontSize', 'quote', 'paragraphFormat', 'paragraphStyle'],
      [
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'formatOL',
        'formatUL',
        'lineHeight',
        'outdent',
        'indent',
      ],
      ['undo', 'redo', 'fullscreen', 'selectAll', 'help'],
    ],
    height: 500,
    width: '100%',
    tabSpaces: 8,
    key: environment.froalaKey,
    attribution: false,
    events: {
      'image.beforeUpload': function (images) {
        // Convertir en base64 sinon on ne stocke que l'url locale de l'image
        const editor = this;

        if (images.length) {
          const reader = new FileReader();

          reader.onload = function (e) {
            editor.image.insert(
              e.target.result,
              null,
              null,
              editor.image.get()
            );
          };

          reader.readAsDataURL(images[0]);
        }

        return false;
      },
    },
  };

  @ViewChild('froalaDrop') public froalaEditorDirective!: FroalaEditorDirective;
  @ViewChild('modalBodyCor') public modalBody: ElementRef;
  @ViewChild('outsideModalCor') public outsideModal: ElementRef;
  @ViewChild('iframeview') public iframe: ElementRef;

  editorInstance: any = null;
  initControls: any = null;
  public modalTitle = 'Envoi de courrier rapide';
  public idPatient: string;
  public title: string;
  public content: string;
  public idTexteModele: string;
  public correspondants: Array<Correspondant>;
  public pieceJointe: PieceJointe;
  public typeDocument: string | null = null;
  public documentId: string;
  public selectedCorrespondants: Correspondant[] = [];
  public idCorrespondant: string;
  public currentAccount: FormGroup;
  public accounts: Array<NgSelectAccount> = [];
  private currentProfil;
  public idNat: string;
  public selectedIdNat: string;
  private _lastProviderSelected: MssTypeService;
  public isMSSSet: boolean;

  public matriculeIns?: string;

  public canSendToPatient = true;
  public canSendToPro = true;
  public isVisibleReciptients = false;
  public envoiPatient = false;
  public printContent: SafeHtml;
  public printContentRaw: string;
  iframeDimensions: { height: number; width: number };
  fichePatient: FichePatient;
  public get accountSelected(): SelectedAccount {
    return this._accountSelected;
  }
  public set accountSelected(account: SelectedAccount) {
    this._mssSrv.switchService(account.provider);
    this._accountSelected = account;
    this._lastProviderSelected = account.provider;
  }
  private _accountSelected: SelectedAccount;

  private userMail: string;
  public isConnected: boolean;
  private authenticationErrorSubscription: Subscription;

  public currentMessagePatient: MSSMessagePatientInfo;
  public messageFormGroup: FormGroup;

  public isApicryptAccount: boolean = false;
  public selectedRecipientsEmails: Correspondant[] = [];
  public selectedCcRecipientsEmails: Correspondant[] = [];
  public selectedBccRecipientsEmails: Correspondant[] = [];

  public annexes?: Annexe[];
  public clinicalDocumentInfo?: MSSClinicalDocumentInfo;

  @Output() public closeEmitter = new EventEmitter();

  @Input() childModal: AddCorrespondantCourrier;

  constructor(
    private _modal: ModalService,
    private _patientSrv: PatientService,
    private _strUtilsSrv: StringUtilsService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _resourceSrv: RessourceService,
    private _formBuilder: FormBuilder,
    private _mssSrv: MssServiceFactory,
    private _documentSrv: DocumentService,
    private _loginSrv: LoginService,
    private _courrier: CourriersService,
    protected domSanitizer: DomSanitizer,
    private _snack: SnackbarService,
    private _insSrv: InsRealservice
    ) {}

  async ngOnInit(): Promise<void> {
    //  this.addRecipients();

    await this._initData();
    if (
      this.content &&
      this.pieceJointe &&
      this.pieceJointe.contentType === 'courrier-consultation'
    ) {
      this.calcIframeDimensions();
      this.generateFirstHTMLContent();
    }
  }

  /**
   * Initialisation de l'éditeur pour accéder aux méthodes de froala pour cibler l'éditeur, pour le drag and drop
   * @param initControls
   */
  initialize(initControls: any) {
    this.initControls = initControls;
    this.initControls.initialize();

    setTimeout(() => {
      this.editorInstance = this.initControls.getEditor();
    });
  }

  private async _initData(): Promise<void> {
    const modal = this._modalSrv.openLoading(this._viewContainerRef);

    const mail =
      this.selectedCorrespondants && this.selectedCorrespondants.length > 0
        ? this.selectedCorrespondants
          .map((c) => (this.isApicryptAccount ? c.adresseApiCrypt : c.email2))
          .filter(Boolean) // évite les vides
        : [];

    this.messageFormGroup = this._formBuilder.group({
      messageRecipients: [mail],
      messageCcRecipients: [[]],
      messageBccRecipients: [[]],
      messageSubject: [this.title ? this.title : '', [Validators.required]],
      messagePatient: ['', [Validators.required]],
      messageBody: [this.content ? this.content : '', Validators.required],
      messageAccuseReception: [false],
      messageEnvoiPatient: [this.envoiPatient],
    });
    const pieceJointeSize = this.pieceJointe?.size || 0;
    const annexesSize = this.annexes?.reduce((acc, annex) => acc + (annex.size || 0), 0) || 0;
    const totalSize = pieceJointeSize + annexesSize;
    if (totalSize > 10000000) {
      await this._openAlertModal(
        'La taille totale des fichiers joints est trop volumineuse (10 Mo max) pour être envoyée par MSS.'
      );
      this.closeModal();
      return;
    }

    if (this.isApicryptAccount) {
      const MAX_APICRYPT_SIZE = 3 * 1024 * 1024; // 3 Mo
      if (pieceJointeSize > MAX_APICRYPT_SIZE) {
        await this._openAlertModal(
          `La pièce jointe principale dépasse la taille maximale de 3 Mo autorisée par Apicrypt.`
        );
        this.closeModal();
        return;
      }
      
      if (this.annexes && this.annexes.length > 0) {
        for (const annexe of this.annexes) {
          if ((annexe.size || 0) > MAX_APICRYPT_SIZE) {
            await this._openAlertModal(
              `L'annexe "${annexe.fileName}" dépasse la taille maximale de 3 Mo autorisée par Apicrypt.`
            );
            this.closeModal();
            return;
          }
        }
      }
    }
    const currentProfilStr = localStorage.getItem('currentProfil');
    let params: Array<RessourceSetting>;
    if (currentProfilStr && currentProfilStr !== '') {
      this.currentProfil = JSON.parse(currentProfilStr);
      params = await this._resourceSrv.getResourceSettings(
        this.currentProfil.id,
        'profil'
      );
      const identifiantNationalSetting = this._resourceSrv.getSettingFromArray(
        params,
        IDENTIFIANT_NATIONAL_KEY
      );
      this.idNat = identifiantNationalSetting
        ? identifiantNationalSetting.value
        : '';
    }

    this.currentAccount = this._formBuilder.group({
      accountName: ['', Validators.required],
    });

    if (this.currentProfil) {
      try {
        const settings = await this._resourceSrv.getResourceSettings(
          (this.currentProfil as Profil).id,
          'profil'
        );
        const addressesStr = this._getSettings(settings, 'mailiz_account');
        if (addressesStr && addressesStr !== '') {
          const addresses: Array<MailizAccount> = JSON.parse(addressesStr);
          for (const address of addresses) {
            this.addAccountsToList(
              MssTypeService.mailiz,
              address.addresses,
              address.idnat
            );
          }
        }
      } catch (e) {
        console.log('error : ', e);
      }

      try {
        this._mssSrv.switchService(MssTypeService.apicrypt);
        const accounts = await this._mssSrv
          .getService()
          .listAccounts(this.selectedIdNat);
        this.addAccountsToList(MssTypeService.apicrypt, accounts);
      } catch (e) {
        console.log('error : ', e);
      }
      this.accounts = [...this.accounts];
    }

    try {
      // On vérifie l'existence qu'une messagerie MSS soit paramétrée
      this.isMSSSet = await this._isMSSSet();
      if (!this.isMSSSet) {
        return;
      }
    } catch (e) {
      await this._openAlertModal(e.message);
    } finally {
      modal.destroy();
    }
  }

  private _getSettings = (
    params: RessourceSetting[],
    settingKey: string
  ): string | undefined => {
    const temp = params.find((p) => p.settingKey === settingKey);
    return temp ? temp.settingValue : undefined;
  };

  private addAccountsToList(
    provider: MssTypeService,
    accounts: Array<string>,
    idNat?: string
  ): void {
    this._mssSrv.switchService(provider);
    for (const account of accounts) {
      if (
        !this.accounts.find(
          (a) =>
            a.id === `${account}$${provider}$${idNat}` ||
            a.id === `${account}$${provider}`
        )
      ) {
        this.accounts.push({
          id: idNat
            ? `${account}$${provider}$${idNat}`
            : `${account}$${provider}`,
          libelle: idNat
            ? `${this._mssSrv
                .getService()
                .providerLibellePrefix()} : ${account} (${idNat})`
            : `${this._mssSrv
                .getService()
                .providerLibellePrefix()} : ${account}`,
        });
      }
    }

    // On switch vers le dernier provider sélectionné
    this.switchToLastSelectedProvider();
  }

  private switchToLastSelectedProvider(): void {
    this._mssSrv.switchService(this._lastProviderSelected);
  }

  private async _isMSSSet(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        let resourceId = '';
        const currentProfilStr = localStorage.getItem('currentProfil');
        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          resourceId = currentProfil.id;
        }
        if (resourceId) {
          const params = await this._resourceSrv.getResourceSettings(
            resourceId,
            'profil'
          );
          if (params) {
            const practiceSetting = this._getSettings(
              params,
              practiceSettingKey
            );
            const identifiantNationalSetting = this._getSettings(
              params,
              identifiantNationalKey
            );
            const professionSetting = this._getSettings(
              params,
              professionSettingKey
            );
            const nomSetting = this._getSettings(params, nomSettingKey);
            const prenomSetting = this._getSettings(params, prenomSettingKey);
            const idnatStructureSetting = this._getSettings(
              params,
              idnatStructureSettingKey
            );
            const nomStructureSetting = this._getSettings(
              params,
              nomStructureSettingKey
            );
            const typeStructureSetting = this._getSettings(
              params,
              typeStructureSettingKey
            );

            resolve(
              !!practiceSetting &&
                !!identifiantNationalSetting &&
                !!professionSetting &&
                !!nomSetting &&
                !!prenomSetting &&
                !!idnatStructureSetting &&
                !!nomStructureSetting &&
                !!typeStructureSetting
            );
          }
        } else {
          resolve(false);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  public async selectAccount(): Promise<void> {
    const select = this.currentAccount.get('accountName').value;
    if (select.includes('apicrypt')) {
      this.isApicryptAccount = true;
    }
    if (select) {
      const selectSplit = (select as string).split('$');
      const account = selectSplit[0];
      const provider = selectSplit[1];
      const idNat = selectSplit[2];

      this.accountSelected = {
        accountName: account,
        provider: provider as MssTypeService,
      };
      const currentUserMail = this.userMail;
      const currentSelectedIdNat = this.selectedIdNat;
      const lastSelectedProvider = this._lastProviderSelected;
      this.userMail = account;
      this.selectedIdNat = idNat;

      try {
        this._mssSrv.switchService(provider as MssTypeService);
        if ((provider as MssTypeService) === MssTypeService.mailiz) {
          if (
            !(await this._mssSrv
              .getService()
              .isSessionValid({ email: account, idNat }))
          ) {
            const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
              this._viewContainerRef,
              ConnectToMailizComponent
            ) as ComponentRef<ConnectToMailizComponent>;

            modal.instance.idNat = idNat;
            const sub = modal.instance.closeEmitter.subscribe(
              async (res: string) => {
                modal.destroy();
                sub.unsubscribe();

                if (res === 'connected') {
                  await this._saveMails(idNat, lastSelectedProvider);
                  await this._connexionOk();
                } else {
                  this.userMail = currentUserMail;
                  this.selectedIdNat = currentSelectedIdNat;
                }
              }
            );
          } else {
            await this._saveMails(idNat, lastSelectedProvider);
            await this._connexionOk();
          }
        } else if ((provider as MssTypeService) === MssTypeService.apicrypt) {
          if (
            !(await this._mssSrv
              .getService()
              .isSessionValid({ email: account, idNat }))
          ) {
            const modal = this._modalSrv.openModal<ConnectToApicryptComponent>(
              this._viewContainerRef,
              ConnectToApicryptComponent
            ) as ComponentRef<ConnectToApicryptComponent>;
            modal.instance.inputAccount = account;
            const sub = modal.instance.closeEmitter.subscribe(
              async (res: string) => {
                modal.destroy();
                sub.unsubscribe();

                if (res === 'connected') {
                  await this._connexionOk();
                } else {
                  this.userMail = currentUserMail;
                  this.selectedIdNat = currentSelectedIdNat;
                }
              }
            );
          } else {
            await this._connexionOk();
          }
        }
      } catch (e) {
        await this._openAlertModal(e.message);
        this.userMail = currentUserMail;
        this.selectedIdNat = currentSelectedIdNat;
      } finally {
        if (this.canSendToPatient) {
          setTimeout(() => {
            this.toggledSendPatient(true);
          }, 0);
        }
      }
    }
  }

  addCorrespondant(option: string) {
    let correspondantsArray: Correspondant[] = [];
    if (option === 'messageRecipients') {
      correspondantsArray = [...this.selectedRecipientsEmails];
    }
    if (option === 'messageCcRecipients') {
      correspondantsArray = [...this.selectedCcRecipientsEmails];
    }
    if (option === 'messageBccRecipients') {
      correspondantsArray = [...this.selectedBccRecipientsEmails];
    }

    const modale: ComponentRef<AddCorrespondantCourrier> =
      this._modal.openModalCorrespondantCourrier(
        this._viewContainerRef,
        this.idPatient,
        this.documentId,
        option,
        correspondantsArray,
        this.isApicryptAccount
      );

    const sub = modale.instance.closeEmitter.subscribe(
      (selectedCorrespondantsEmails) => {
        if (
          selectedCorrespondantsEmails &&
          selectedCorrespondantsEmails.length > 0
        ) {
          const emailsList = selectedCorrespondantsEmails.map((c) => c.email);
          this.messageFormGroup.get(option).setValue(emailsList);
          if (option === 'messageRecipients') {
            this.selectedRecipientsEmails = [...selectedCorrespondantsEmails];
          }
          if (option === 'messageCcRecipients') {
            this.selectedCcRecipientsEmails = [...selectedCorrespondantsEmails];
          }
          if (option === 'messageBccRecipients') {
            this.selectedBccRecipientsEmails = [
              ...selectedCorrespondantsEmails,
            ];
          }
        } else {
          this.messageFormGroup.get(option).setValue([]);
          this.selectedCorrespondants = [];
        }

        sub.unsubscribe();
      }
    );
  }

  // addRecipients(){
  //    this._modal.closeEmitter.subscribe((selectedCorrespondants: Correspondant[]) => {
  //     if (selectedCorrespondants) {
  //       this.selectedCorrespondants = selectedCorrespondants;
  //       this._initData()
  //       // const emailsList = selectedCorrespondants
  //       //   .map(c => c.email1 || c.adresseApiCrypt || c.email2)
  //       //   .join(',');
  //       // this.messageFormGroup.get('messageRecipients').setValue(emailsList);
  //       // console.log("emaillist",emailsList);
  //     }
  //   });
  // }

  private _openAlertModal(msg: string, title = 'Erreur'): Promise<void> {
    return new Promise((resolve, _) => {
      const alertModale = this._modalSrv.openAlert(
        this._viewContainerRef,
        title,
        msg
      );
      const sub = alertModale.instance.closeEmitter.subscribe(
        async (response) => {
          sub.unsubscribe();
          resolve();
        }
      );
    });
  }

  private async _connexionOk(): Promise<void> {
    try {
      await this._initProvider();
      this.isConnected = true;
      await this._initMessage();
    } catch (e) {
      await this._openAlertModal(e.message);
      this.closeModal();
    }
  }

  private async _initMessage(): Promise<void> {
    let patientInputValue = '';
    if (this.idPatient) {
      const patient = await this._patientSrv.findOnePatientInfos(
        this.idPatient
      );
      const couverture = await this._patientSrv.findOnePatientCouverture(
        this.idPatient
      );
      this.fichePatient = await this._patientSrv.findOnePatientFiche(
        this.idPatient
      );

      patientInputValue = `${this._strUtilsSrv.uppercaseFirstCharString(
        patient.prenom
      )} ${patient.nom.toLocaleUpperCase()}`;
      this.currentMessagePatient = {
        patientId: this.idPatient,
        firstName: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom),
        lastName: patient.nom.toLocaleUpperCase(),
        birthDate: patient.dateNaissance,
        couverture,
      };
      // APE - HACK WARNING : Si identité statut ID bouge en base il faudra changer ça
      const isQualifie = this.fichePatient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf';
      const isRecupere = this.fichePatient.identiteStatutId === '8ba51292-17bb-4215-93bc-0ac6217655a1';
      const isValidNir = !!this.fichePatient.ins && !!this.fichePatient.insKey && this._insSrv.validateNirAndCrossCheck(this.fichePatient.ins, this.fichePatient.insKey, this.fichePatient.sexe, this.fichePatient.dateNaissance);

      this.canSendToPatient = this.fichePatient.mssPatientConsentement && (isQualifie || isRecupere || isValidNir);

      this.canSendToPro = this.fichePatient.mssProConsentement ?? false;
      if (!this.canSendToPatient) {
        this.messageFormGroup.get('messageEnvoiPatient').disable();
      } else {
        this.matriculeIns = this.fichePatient.ins + this.fichePatient.insKey;
      }
    } else {
      throw new Error('Patient non trouvé');
    }

    if (this.pieceJointe) {
      // cas compte mss et patient sans ins ou oid
      if (
        this.currentMessagePatient &&
        !this.isApicryptAccount &&
        !this.canSendToPatient
      ) {
        this._snack.openSnackBarWarning("Ce patient ne possède pas de INS ou d'OID dans sa fiche patient, il sera impossible d'envoyer un document de santé le concernant.")
        this._setClinicalDocument(false);
      } else if (
        this.currentMessagePatient &&
        !this.isApicryptAccount &&
        !this.canSendToPro
      ) {
        //compte mss et pas de mssProConsentement
        this._snack.openSnackBarWarning("Ce patient n'a pas donné son consentement pour l'envoi de documents de santé aux professionnels de santé le concernant. Il sera impossible d'envoyer un document de santé le concernant." )
        this._setClinicalDocument(false);
      } else if (
        this.currentMessagePatient &&
        !this.isApicryptAccount &&
        !this.canSendToPro &&
        !this.canSendToPatient
      ) {
        //cas mss et pas INS ni MSS ProConsentement
        this._snack.openSnackBarWarning("Ce patient n'a pas donné son consentement pour l'envoi de documents de santé aux professionnels de santé le concernant et ne possède pas de INS dans sa fiche patient. Il sera impossible d'envoyer un document de santé le concernant.")
        this._setClinicalDocument(false);
      } else if (this.isApicryptAccount && !this.canSendToPro) {
        //cas apicrypt et pas de mssProConsentement
        this._snack.openSnackBarWarning( "Ce patient n'a pas donné son consentement pour l'envoi de documents de santé aux professionnels de santé le concernant. Il sera impossible d'envoyer un document de santé le concernant.")
        
        this._setClinicalDocument(false);
      } else {
        this._setClinicalDocument(true);
      }
    }

    this.messageFormGroup.get('messagePatient').setValue(patientInputValue);
  }

private _setClinicalDocument(value: boolean): void {
  if (this.pieceJointe) {
    if (value) {
      this.pieceJointe.clinicalDocument = true;
    } else {
      delete this.pieceJointe.clinicalDocument;
    }
  }
}


  showCCandCCI() {
    this.isVisibleReciptients = !this.isVisibleReciptients;
  }

  private async _initProvider(): Promise<void> {
    if (!this.authenticationErrorSubscription) {
      this.authenticationErrorSubscription = this._mssSrv
        .getService()
        .authenticationErrorSubject.subscribe(async (isLogged) => {
          if (!isLogged) {
            this.isConnected = false;
            if (this._mssSrv.getService().isTokenNeeded()) {
              this._mssSrv.getService().clearToken(this.selectedIdNat);
            }

            if (this._lastProviderSelected === MssTypeService.mailiz) {
              const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
                this._viewContainerRef,
                ConnectToMailizComponent
              ) as ComponentRef<ConnectToMailizComponent>;

              modal.instance.idNat = this.selectedIdNat;
              const sub = modal.instance.closeEmitter.subscribe(
                async (res: string) => {
                  modal.destroy();
                  sub.unsubscribe();

                  if (res === 'connected') {
                    await this._saveMails(
                      this.selectedIdNat,
                      this._lastProviderSelected
                    );
                    await this._connexionOk();
                  } else {
                    this.userMail = undefined;
                    this.selectedIdNat = undefined;
                  }
                }
              );
            } else if (this._lastProviderSelected === MssTypeService.apicrypt) {
              const modal =
                this._modalSrv.openModal<ConnectToApicryptComponent>(
                  this._viewContainerRef,
                  ConnectToApicryptComponent
                ) as ComponentRef<ConnectToApicryptComponent>;
              modal.instance.inputAccount = this.accountSelected.accountName;
              const sub = modal.instance.closeEmitter.subscribe(
                async (res: string) => {
                  modal.destroy();
                  sub.unsubscribe();

                  if (res === 'connected') {
                    await this._connexionOk();
                  } else {
                    this.userMail = undefined;
                    this.selectedIdNat = undefined;
                  }
                }
              );
            }
          } else {
            this.isConnected = true;
          }
        });
    }
  }

  private async _saveMails(
    idNat: string,
    previousSelectedProvider: MssTypeService
  ): Promise<void> {
    this._mssSrv.switchService(MssTypeService.mailiz);
    const accounts = await this._mssSrv.getService().listAccounts(idNat);
    if (accounts) {
      this.addAccountsToList(MssTypeService.mailiz, accounts, idNat);

      const settings = await this._resourceSrv.getResourceSettings(
        this.currentProfil.id,
        'profil'
      );
      const addressesStr = this._getSettings(settings, 'mailiz_account');
      let addresses: Array<MailizAccount> = [];
      if (addressesStr && addressesStr !== '') {
        addresses = JSON.parse(addressesStr);
        let found = false;
        for (const address of addresses) {
          if (address && address.idnat === idNat) {
            address.addresses = accounts;
            found = true;
          }
        }
        if (!found) {
          addresses.push({
            idnat: idNat,
            addresses: accounts,
          });
        }
        await this._resourceSrv.postResourceSettings(
          (this.currentProfil as Profil).id,
          'profil',
          {
            ressourceId: (this.currentProfil as Profil).id,
            ressourceType: RessourceTypeEnum.Profil,
            settingKey: `mailiz_account`,
            settingType: 'object',
            settingValue: JSON.stringify(addresses),
          }
        );
      } else {
        const value = [
          {
            idnat: idNat,
            addresses: accounts,
          },
        ];
        await this._resourceSrv.postResourceSettings(
          (this.currentProfil as Profil).id,
          'profil',
          {
            ressourceId: (this.currentProfil as Profil).id,
            ressourceType: RessourceTypeEnum.Profil,
            settingKey: `mailiz_account`,
            settingType: 'object',
            settingValue: JSON.stringify(value),
          }
        );
      }
    }

    if (previousSelectedProvider) {
      this._mssSrv.switchService(previousSelectedProvider);
    }
  }

  // public findRecipients(recipientType: 'messageRecipients' | 'messageCcRecipients' | 'messageBccRecipients'): void {
  //   const modal = this._modalSrv.openModal<MssRecipientSearchComponent>(
  //     this._viewContainerRef,
  //     MssRecipientSearchComponent
  //   ) as ComponentRef<MssRecipientSearchComponent>;

  //   const sub = modal.instance.closeEmitter.subscribe((res: string) => {
  //     if (res && res !== '') {
  //       let inputValue = this.messageFormGroup.get(recipientType).value;
  //       inputValue += (inputValue !== '' ? ',' : '')  + res;
  //       this.messageFormGroup.get(recipientType).setValue(inputValue);
  //     }
  //     modal.destroy();
  //     sub.unsubscribe();
  //   });
  // }

  public async sendMessage(): Promise<void> {
    const isApicrypt = this.isApicryptAccount || this._lastProviderSelected === MssTypeService.apicrypt;
    if (isApicrypt) {
      const MAX_APICRYPT_SIZE = 3 * 1024 * 1024; // 3 Mo
      const pieceJointeSize = this.pieceJointe?.size || 0;
      if (pieceJointeSize > MAX_APICRYPT_SIZE) {
        await this._openAlertModal(
          `La pièce jointe principale dépasse la taille maximale de 3 Mo autorisée par Apicrypt.`
        );
        return;
      }
      
      if (this.annexes && this.annexes.length > 0) {
        for (const annexe of this.annexes) {
          if ((annexe.size || 0) > MAX_APICRYPT_SIZE) {
            await this._openAlertModal(
              `L'annexe "${annexe.fileName}" dépasse la taille maximale de 3 Mo autorisée par Apicrypt.`
            );
            return;
          }
        }
      }
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    const message = this._getMessageToSendFromForm();

    if (!message) {
      loading.destroy();
      return;
    }
    // Chargement du courrier uniquement s'il y en a un associé.
    // Pour les envois CS9/CS24 depuis editeur-formulaire, il n'y en a pas.
    let createCourrier: CreateCourrier | null = null;
    let courrier: Courrier | null = null;
    if (this.documentId) {
      courrier = await this._courrier.findOne(this.documentId);
      createCourrier = {
        idConsultation: courrier.consultation.id,
        titre: courrier.titre,
        versionCourrier: courrier.versionCourrier
      };
    }

    if (
      this.pieceJointe &&
      this.pieceJointe.contentType === 'courrier-consultation'
    ) {
      const dests: CourrierDestinataires = {};
      if (
        this.messageFormGroup.get('messageRecipients').value &&
        this.messageFormGroup.get('messageRecipients').value !== ''
      ) {
        dests.to = this.messageFormGroup.get('messageRecipients').value;
      }
      if (
        this.messageFormGroup.get('messageCcRecipients').value &&
        this.messageFormGroup.get('messageCcRecipients').value !== ''
      ) {
        dests.cc = this.messageFormGroup.get('messageCcRecipients').value;

      }
      if (
        this.messageFormGroup.get('messageBccRecipients').value &&
        this.messageFormGroup.get('messageBccRecipients').value !== ''
      ) {
        dests.bcc = this.messageFormGroup.get('messageBccRecipients').value;
      }
      
      const b64 = await this._courrier.convertToPdf(
        {
          idConsultation: '',
          titre: this.title,
          versionCourrier: 0,
          courrierText: this.pieceJointe.file,
          isEnteteVide: false,
          isPiedVide: false,
        },
        dests,
        this.fichePatient
      );

      if (this.printContentRaw) {
        message.messageData.attachments = [
          {
            contentType: 'application/pdf',
            file: b64,
            fileName: this.pieceJointe.fileName + '.pdf',
            clinicalDocument: this.pieceJointe.clinicalDocument,
            documentAssocieId: this.pieceJointe.documentAssocieId,
          },
        ];

        const uploadFile: UploadGedDocument = {
          content: b64,
          fileName: this.pieceJointe.fileName + '.pdf',
          mime: 'application/pdf',
        };
        const documentGEDId = await this._documentSrv.uploadFile(uploadFile);

        let existingDocument;

        try {
          existingDocument =
            await this._documentSrv.getDocumentByDocumentAssocieId(
              this.pieceJointe.documentAssocieId
            );
        } catch {}


        if (existingDocument) {
          await this._documentSrv.updateDocument(
            existingDocument.id,
            {
              contentType: 'application/pdf',
              fileName: this.pieceJointe.fileName,
              gedId: documentGEDId,
              titre: message.messageData.subject,
              typeId: 'b98d0840-13c5-44ef-a927-99610bb9174a', // correspond à autre dans référentiel général
              consultationId: courrier.consultation.id,
              authorId: this._loginSrv.getCurrentProfil().id,
              weight: atob(b64.substring(b64.indexOf(',') + 1)).length,
              documentAssocieId: this.pieceJointe.documentAssocieId,
              typeDocumentAssocie: this.pieceJointe.typeDocumentAssocie,
            },
            true
          );
        } else {
          try{
            await this._documentSrv.createDocument(
            message.patientInfo.patientId,
            {
              contentType: 'application/pdf',
              fileName: this.pieceJointe.fileName,
              gedId: documentGEDId,
              titre: message.messageData.subject,
              typeId: 'b98d0840-13c5-44ef-a927-99610bb9174a', // correspond à autre dans référentiel général
              consultationId: courrier.consultation.id,
              authorId: this._loginSrv.getCurrentProfil().id,
              weight: atob(b64.substring(b64.indexOf(',') + 1)).length,
              documentAssocieId: this.pieceJointe.documentAssocieId,
              typeDocumentAssocie: this.pieceJointe.typeDocumentAssocie,
            }
          );
          }catch(error){ 
            const msg = error?.error?.message || error.message || "Erreur inconnue";
            this._snack.openSnackBarError(msg);
            loading.destroy();
            return;
          }
          
        }
      }
    }

    // Ajouter les annexes (images/PDFs) comme pièces jointes supplémentaires
    if (this.annexes && this.annexes.length > 0) {
      for (const annexe of this.annexes) {
        // Ajouter le préfixe data URI si absent
        let fileData = annexe.base64Data;
        if (!fileData.startsWith('data:')) {
          fileData = `data:${annexe.contentType};base64,${fileData}`;
        }
        
        message.messageData.attachments.push({
          contentType: annexe.contentType,
          file: fileData,
          fileName: annexe.fileName,
          clinicalDocument: false, // Pour l'instant toutes les pièces jointes sont envoyés en tant que documents non cliniques
        });
      }
    }
    try {
      let askForClinicalInfo = this.clinicalDocumentInfo;
      if (
        !askForClinicalInfo &&
        message.messageData.attachments.length >= 1 &&
        message.messageData.attachments[0].clinicalDocument
      ) {
        // On essaye d'envoyer le message en mode clinical document
        askForClinicalInfo = await new Promise<
          MSSClinicalDocumentInfo | undefined
        >(async (resolve, reject) => {
          try {
            const modal =
              this._modalSrv.openModal<PresendClinicalDocumentModalComponent>(
                this._viewContainerRef,
                PresendClinicalDocumentModalComponent
              ) as ComponentRef<PresendClinicalDocumentModalComponent>;
            modal.instance.setDocTitle(
              message.messageData.attachments[0].fileName
            );
            if (this.idTexteModele) {
              modal.instance.idTexteModele = this.idTexteModele;
            }
            if(this.typeDocument){
              modal.instance.typeDocument = this.typeDocument;
            }
            const sub = modal.instance.closeEmitter.subscribe(
              (infos?: MSSClinicalDocumentInfo) => {
                resolve(infos);
                modal.destroy();
                sub.unsubscribe();
              }
            );
          } catch (e) {
            reject(e);
          }
        });
      }

      // On envoi le message (avec ou sans les metadata cliniques)
      await this._mssSrv
        .getService()
        .sendMessage(
          { email: this.userMail, idNat: this.selectedIdNat },
          message,
          askForClinicalInfo
        );
      loading.destroy();

      if (this.documentId && createCourrier) {
        if (this.annexes && this.annexes.length > 0) {
          const annexesTitles = this.annexes.map((annexe) => annexe.fileName);
           await this._courrier.update(createCourrier ,this.documentId, annexesTitles);
        }
      }


     this._snack.openSnackBarSuccess("votre message a bien été envoyé.")
      this.closeModal();

    } catch (e) {
      await this._openAlertModal(e.message);
      loading.destroy();
    }
  }

  private _computedStyleToInlineStyle(element, options) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!element) {
      throw new Error('No element specified.');
    }

    if (options.recursive) {
      for (const child of element.children) {
        this._applyStyle(child, options);
      }
    }
    this._applyStyle(element, options);
  }

  private _applyStyle(element, options) {
    var computedStyle = window.getComputedStyle(element);
    const keys = Object.keys(computedStyle);
    let cssStr = '';
    for (const key of keys) {
      if (
        computedStyle[key] !== '' &&
        Number.isNaN(Number(computedStyle[key]))
      ) {
        const value = computedStyle[key];
        if (value) {
          cssStr += `${key}: ${value};`;
        }
      }
    }
    element.style.cssText = cssStr;
  }

  private _getMessageToSendFromForm(
    draftMode = false
  ): MSSMessageToSend | undefined {
    const addresses: Array<MSSAddress> = [];
    let body: string;
    let subject: string;

    const currentProfilStr = localStorage.getItem('currentProfil');
    let currentProfil: Profil;
    if (currentProfilStr && currentProfilStr !== '') {
      currentProfil = JSON.parse(currentProfilStr) as Profil;
    }

    if (this.messageFormGroup) {
      addresses.push({
        email: this.userMail,
        type: MSSEnumTypeMail.FROM,
        name:
          currentProfil &&
          currentProfil.utilisateur &&
          currentProfil.utilisateur.prenom &&
          currentProfil.utilisateur.nom
            ? `${currentProfil.utilisateur.prenom} ${currentProfil.utilisateur.nom}`
            : undefined,
      });

      const addressesArr = this.messageFormGroup.get('messageRecipients').value as string[];
      let isRecipient = false;
      for (let address of addressesArr) {
          address = address.trim().toLocaleLowerCase();
          if (address !== '' && address.match(MSS_EMAIL_REGEX)) {
                  addresses.push({
                      email: address,
                      type: MSSEnumTypeMail.TO,
                  });
                  isRecipient = true;              
          }
      }

      if (!isRecipient && !draftMode) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Au moins un destinataire est obligatoire pour envoyer un message'
        );
        return undefined;
      }

      const ccAddressesArr = this.messageFormGroup.get('messageCcRecipients')
        .value as string[];
      for (let address of ccAddressesArr) {
        address = address.trim().toLocaleLowerCase();
        if (
          address !== '' &&
          address.match(MSS_EMAIL_REGEX) &&
          addresses[0].email !== address
        ) {
          addresses.push({
            email: address,
            type: MSSEnumTypeMail.CC,
          });
        }
      }

      const bccAddressesArr = this.messageFormGroup.get('messageBccRecipients')
        .value as string[];
      for (let address of bccAddressesArr) {
        address = address.trim().toLocaleLowerCase();
        if (
          address !== '' &&
          address.match(MSS_EMAIL_REGEX) &&
          addresses[0].email !== address
        ) {
          addresses.push({
            email: address,
            type: MSSEnumTypeMail.BCC,
          });
        }
      }

      body = this.messageFormGroup.get('messageBody').value as string;
      subject = this.messageFormGroup.get('messageSubject').value as string;
    }
    let attachments: MSSAttachment[] = [];

    if (this.pieceJointe) {
      attachments = [
        {
          contentType: this.pieceJointe.contentType,
          file: this.pieceJointe.file,
          fileName: this.pieceJointe.fileName,
          clinicalDocument: this.pieceJointe.clinicalDocument,
          documentAssocieId: this.pieceJointe.documentAssocieId,
          clinicalDocumentData: this.pieceJointe.clinicalDocumentData,
        },
      ];
    }

    let rtd: MSSMessageToSend;
    rtd = {
      messageData: {
        addresses,
        attachments,
        body,
        isHtml: true,
        isAccuse: this.messageFormGroup.get('messageAccuseReception')
          .value as boolean,
        subject,
      },
    };

    /** Si un patient a été selectionné dans le formulaire */
    /** On modifie le titre */
    if (this.currentMessagePatient) {
      rtd.patientInfo = this.currentMessagePatient;
      if (!subject.startsWith(MssMessageDisplayComponent.titlePrefix)) {
        rtd.messageData.subject = `${MssMessageDisplayComponent.titlePrefix}${subject} ${this.currentMessagePatient.lastName} ${this.currentMessagePatient.firstName} ${this.currentMessagePatient.birthDate}`;
      }
    }

    return rtd;
  }

  public async toggledSendPatient(value): Promise<void> {
    const destinataires = this._getDestinataires();
    if (!this.canSendToPatient) {
      console.error('Impossible d\'envoyer un message à un patient');
      return;
    }
    let addressPatient = this.matriculeIns + PATIENT_MSS_ADDRESS_SUFFIX;
    if (environment.mssPatientTest) {
      // addressPatient = `reponse.automatique-test${PATIENT_MSS_ADDRESS_SUFFIX}`;
      addressPatient = undefined;
    }
    const cleanedDestinataires = destinataires.filter((destinataire) => !destinataire.endsWith(PATIENT_MSS_ADDRESS_SUFFIX));
    
    if (value && addressPatient) {
      const isQualifie = this.fichePatient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf';
      const isRecupere = this.fichePatient.identiteStatutId === '8ba51292-17bb-4215-93bc-0ac6217655a1';
      
      if (!isQualifie && !isRecupere) {
        const dateNaissanceStr = moment(this.fichePatient.dateNaissance, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY');
        const modal = this._modalSrv.openModalConfirmation(
          this._viewContainerRef,
          'Confirmation d\'envoi au patient',
          `L'identité de ce patient n'est pas qualifiée.\n\nAfin d'éviter tout envoi erroné, veuillez confirmer que le sexe et la date de naissance de ce patient sont bien :\n\n- Sexe : ${this.fichePatient.sexe || 'Non renseigné'}\n- Date de naissance : ${dateNaissanceStr}\n\nConfirmez-vous ces informations pour générer l'adresse de messagerie ?`
        );

        const isConfirmed = await new Promise<boolean>((resolve) => {
          const subConfirm = modal.instance.closeEmitter.subscribe((res: boolean) => {
            subConfirm.unsubscribe();
            modal.destroy();
            resolve(res);
          });
        });

        if (!isConfirmed) {
          setTimeout(() => {
            this.messageFormGroup.get('messageEnvoiPatient').setValue(false, { emitEvent: false });
          });
          return;
        }
      }

      cleanedDestinataires.push(addressPatient);
    }
    this._setDestinataires(cleanedDestinataires);

    const checkbox = document.getElementById('quick-send-envoi-patient-checkbox');
    if (checkbox && !!(checkbox as any).checked !== value) {
      (checkbox as any).checked = true;
    }
  }

  private _getDestinataires(): Array<string> {
    const addressesArr = this.messageFormGroup.get('messageRecipients').value as string[];
    if (!addressesArr) {
      return [];
    }
    return addressesArr.map((address)=> address.trim());
  }

  private _setDestinataires(destinataires: Array<string>): void {
    this.messageFormGroup.get('messageRecipients').setValue(destinataires);
  }

  public removeCorrespondant(index: number, option: string): void {
    if (option === 'messageRecipients') {
      this.selectedRecipientsEmails.splice(index, 1);
      this.messageFormGroup
        .get('messageRecipients')
        .setValue(this.selectedRecipientsEmails.join(', '));
    }
    if (option === 'messageCcRecipients') {
      this.selectedCcRecipientsEmails.splice(index, 1);
      this.messageFormGroup
        .get('messageCcRecipients')
        .setValue(this.selectedCcRecipientsEmails.join(', '));
    }
    if (option === 'messageBccRecipients') {
      this.selectedBccRecipientsEmails.splice(index, 1);
      this.messageFormGroup
        .get('messageBccRecipients')
        .setValue(this.selectedBccRecipientsEmails.join(', '));
    }
  }

  public closeModal(): void {
    this.closeEmitter.emit(null);
  }

  public cancel(): void {
    this._snack.openSnackBarError("Envoi MSSanté annulé");
    this.closeModal();
  }

  public generateFirstHTMLContent(): void {
    this.content = SafeHtmlUtils.sanitizeHtmlString(this.content);
    const fullHtml = `<html>
      <body>
        <div id="editor">
          <div style="height: 100%; display: flex; flex-direction: column;">
            <div>${this.content}</div>
          </div>
        </div>
      </body>
    </html>`;
    this.printContentRaw = fullHtml;
    this.printContent = this.domSanitizer.bypassSecurityTrustHtml(fullHtml);
  }

  public calcIframeDimensions(): void {
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    this.iframeDimensions = {
      height: (vh * MAX_HEIGHT) / 100,
      width: 0,
    };
  }
}
